import { render } from "./schools-neighbourhood.vue?vue&type=template&id=10fb9ee5"
import script from "./schools-neighbourhood.js?vue&type=script&lang=js"
export * from "./schools-neighbourhood.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__